<template>
  <div
    v-if="request.requestType === 'OFR'"
    class="mt-3"
  >
    <div v-if="request.requestSubType ==='wholesale'">
      <div class="mt-3 mb-1">
        <span>{{ $t('offerExtrasView.minimumSifariMiqdar') }}</span>
        <span class="text-dark">{{ requestExtras.minOrder }} {{ requestExtras.unit }}</span>
      </div>
      <div class="mb-1">
        <span>{{ $t('offerExtrasView.topdanSatQiymti1N', {unit: requestExtras.unit}) }} </span>
        <span class="text-dark">{{ $t('offerExtrasView.azn', {price: requestExtras.price}) }}</span>
      </div>
    </div>
    <div class="mb-1">
      <span>{{ $t('offerExtrasView.dniSulu') }} </span>
      <span class="text-dark">
        <span v-if="requestExtras.payment==='transfer'">{{ $t('offerExtrasView.krm') }}</span>
        <span v-else-if="requestExtras.payment==='cash'">{{ $t('offerExtrasView.nad') }}</span>
        <span v-else-if="requestExtras.payment==='both'">{{ $t('offerExtrasView.hrIkisi') }}</span>
        <span v-else>{{ requestExtras.payment }}</span>
      </span>
    </div>
    <div
      v-if="request.requestSubType !=='service'"
      class="mb-1"
    >
      <span>{{ $t('offerExtrasView.atdrlma') }} </span>
      <span class="text-dark">
        <span v-if="requestExtras.delivery==='no'">{{ $t('offerExtrasView.yoxdur') }}</span>
        <span v-else-if="requestExtras.delivery==='yes'">{{ $t('offerExtrasView.qiymtDaxildir') }}</span>
        <span v-else-if="requestExtras.delivery==='paid'">{{ $t('offerExtrasView.qiymtDaxilDeyil') }}</span>
        <span v-else>{{ requestExtras.delivery }}</span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OfferExtrasView',
  props: {
    request: {},
    requestExtras: {}
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>